import React, { useMemo, useState, useEffect } from 'react';
import { Select, MenuItem } from '@mui/material';
import { minimalInputTheme } from '@/app/theme';
import { useInsightListSourceOfBusinessQuery } from '@/features/properties/propertiesApi';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';

export const SourceOfBusinessSelect = ({ initialValue, disabled, onChange, minimal }) => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });

	const sourceOfBusinessData = useInsightListSourceOfBusinessQuery(undefined, {
		skip: !userDetails?.userId,
	});

	const sourceOfBusinessResults = useMemo(() => {
		return sourceOfBusinessData?.data?.Results?.map(item => ({
			value: item.Value,
			label: item.Label,
		})) ?? [];
	}, [sourceOfBusinessData?.data?.Results]);

	const [sourceOfBusiness, setSourceOfBusiness] = useState(null);

	const updateSourceOfBusiness = (value) => {
		const selected = sourceOfBusinessResults.find(option => option.value == value || option.label == value);
		setSourceOfBusiness(selected ?? null);
	};


	useEffect(() => {
		if (initialValue && sourceOfBusinessResults.length > 0) {
			updateSourceOfBusiness(initialValue);
		}
	}, [initialValue, sourceOfBusinessResults]);

	useEffect(() => {
		if (sourceOfBusiness && sourceOfBusiness.value !== null) {
			if (sourceOfBusiness.value !== initialValue && sourceOfBusiness.label !== initialValue) {
				onChange(sourceOfBusiness.value);
			}
		}
	}, [sourceOfBusiness]);


	return (
		<Select
			className={minimal ? 'minimal-input' : ''}
			value={sourceOfBusiness?.value ?? ''}
			size={minimal ? 'small' : 'medium'}
			disabled={disabled || sourceOfBusinessData?.isLoading || sourceOfBusinessData?.isUninitialized}
			onChange={(e) => updateSourceOfBusiness(e.target.value)}
			displayEmpty
			fullWidth
			variant={minimal ? 'standard' : 'outlined'}
			sx={{
				...(minimal && {
					...minimalInputTheme,
					'& .Mui-disabled': {
						backgroundColor: 'transparent',
					},
				}),
			}}
		>
			{sourceOfBusinessResults.map((option) => (
				<MenuItem
					value={option.value}
					key={`source-of-business-${option.value}`}
				>
					{option.label}
				</MenuItem>
			))}
		</Select>
	);
};
